import { Price, Store } from 'src/types';
import { CurrentCampaign, ProductPriceType } from 'src/areas/product/types';
import RatingHelper from 'src/components/rating/rating-helper';
import { Rating } from 'src/components/rating/types';
import { Offer } from '../price-row/types';
import { Option, OptionTypeEnum } from 'src/components/filter-dropdown';
import { TranslateFunc } from 'components/translate/src/translate-func';

const getValidPriceType = (type?: string | null) => {
  if (
    !type ||
    !Object.values(ProductPriceType).includes(type as ProductPriceType)
  )
    return null;

  return type as ProductPriceType;
};

const getStoreRating = (store?: Store | null): Rating | undefined => {
  return store?.userReviewSummary?.rating
    ? RatingHelper.convert(store.userReviewSummary.rating)
    : undefined;
};

export const getCampaignByOfferId = (
  offerId?: string | null,
  campaign?: CurrentCampaign | null
) => {
  return campaign?.price &&
    campaign?.media &&
    campaign?.name &&
    offerId === campaign.price.id
    ? campaign
    : null;
};

export function createOfferFromPriceItem(item: Price): Offer {
  return {
    name: item.name,
    price: item.price,
    offerPrices: item.offerPrices,
    priceId: item.id,
    priceType: getValidPriceType(item.type),
    deliveryOptions: item.deliveryOptions ?? [],
    store: item.store,
    featured: Boolean(item.store?.featured),
    storeInfo:
      item.store && item.store.providedByStore
        ? item.store.providedByStore.generalInformation
        : null,
    rating: getStoreRating(item.store),
    stock: item.stock,
    externalUri: item.externalUri,
    alternativePrices: item.alternativePrices,
    authorizedDealer: Boolean(item.authorizedDealer),
    isInternationalPrice: Boolean(
      item.store && item.store.market === 'secondary'
    ),
    shipping: item.shipping,
  };
}

export const getSortOptions = (t: TranslateFunc): Option[] => [
  {
    title: t('campaigns', 'sort.price.offer|asc'),
    type: OptionTypeEnum.CHEAPEST_PRICE,
  },
  {
    title: t('common', 'sort.fastest-delivery'),
    type: OptionTypeEnum.FASTEST_DELIVERY,
  },
];
